import React from 'react';
import './App.css';

import Header from './Header/Header';
import Pagina from './Produtos/Pagina';
import Footer from './Footer/Footer';

import coca from './img/coca.png'
import { useState } from 'react';

function App() {

  return (
    <div className="App">
      <Header />
      <Pagina />
      <Footer />
    </div>
  );
}

export default App;
